import axios from "axios";
import { DELETE, GET, PATCH, POST, AUTH, PUT, API_KEY, ADMIN, OPTION, BASE_URL, OTHER_PATH } from "../app.config";
import Cookies from "js-cookie";
import { Decryption, Encryption, logoutRedirection, TOAST_ERROR } from "./common.service";

const request = async (url, method, token, payload, params = {}) => {
  //console.log("url- ---_- - -  - - - - - >>>>>",url);
  
  try {
    const allowedMethodTypes = [GET, POST, PUT, PATCH, DELETE, OPTION];

    if (allowedMethodTypes.indexOf(method.toLowerCase()) < 0) {
      throw new Error(`Invalid method type please provide one of these methods... \n ${allowedMethodTypes}`);
    }
    const headers = {
      "api-key": Encryption(API_KEY, true),
      'Accept-language': 'en',
      //  'Content-Type': 'application/json',
      'Content-Type': 'text/plain',
      'app': 'A',
      ...(token && { token: Cookies.get('tokenCA') }),
    };

    //console.log("aheaders------------------------", headers)  
    //console.log(Cookies.get('tokenCA'));
  
    

    // // const result = await axios({ method, url, baseURL: BASE_URL, params, data:payload, headers});
     const result = await axios({ method, url, baseURL: BASE_URL, params, data: Encryption(payload, true), headers});
     //console.log("result---------------------------",  result)
     let decodeData = await Decryption(result?.data); 
    //  let decodeData = await result?.data;
    if (decodeData?.code === '0') {
       //console.log(decodeData?.message);
      
       TOAST_ERROR(decodeData?.message)
    }
    return decodeData;
  } catch (error) {
    let decodeData = await Decryption(error?.response?.data);
    //console.log("decodeData", decodeData)
    if (decodeData?.code == -1) {
      logoutRedirection();
    //   let path = window.location.protocol + "//" + window.location.host + "/" + OTHER_PATH + "login"
    //   window.location.href = path;
    } else {
      //console.log(error);
      
      throw new Error(error);
    }
  }
};
export default request;